import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import API from '../../../utils/API';

function SignageCanvaOauth() {
    const [text, setText] = useState('')
    const initialized = useRef(false)
    useEffect(()=>{
        if (!initialized.current) {
            initialized.current = true
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            API.postCanvaToken(urlParams.get('code'))
            .then((res)=>{
                console.log(res);
                console.log('Successfully connected to canva');
                window.location.href = '/signage-plus/create-playlist?tab=canva'
            }).catch((err)=>{
                console.log(`Error connecting user to canva`);
                setText(`Error connecting user to canva, returning to playlist management page`);
                setTimeout(()=>{
                    window.location.href = '/signage-plus/create-playlist?tab=canva'
                }, 5000)
            })
        }
    },[])

    return (
        <div style={{fontSize: 32}}>
            {text}
        </div>
    )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(SignageCanvaOauth)